'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PasswordControl = function () {
  function PasswordControl(element, args) {
    _classCallCheck(this, PasswordControl);

    var div = document.createElement('div');
    this.input = document.createElement('input');
    this.input.id = window.PRIM.getUUID();
    this.input.value = args.value ? args.value : '';
    this.input.type = 'password';
    this.input.disabled = args.readonly ? 'disabled' : '';
    this.input.onchange = args.onchange;
    this.label = document.createElement('label');
    this.label.innerHTML = args.label;
    this.label.htmlFor = this.input.id;
    var fragment = document.createDocumentFragment();
    fragment.appendChild(div);
    div.appendChild(this.label);
    div.appendChild(this.input);

    element.appendChild(fragment);
  }

  _createClass(PasswordControl, [{
    key: 'setLabel',
    value: function setLabel(text) {
      this.label.innerHTML = text;
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.input.value ? this.input.value : null;
    }
  }, {
    key: 'setValue',
    value: function setValue(value) {
      this.input.value = value;
    }
  }]);

  return PasswordControl;
}();

exports.default = PasswordControl;


//////////////////
// WEBPACK FOOTER
// ./js/lib/ui/PasswordControl.js
// module id = 75
// module chunks = 0